import styled from 'styled-components';

export const OrderStatus = styled.div`
  color: var(--welcome);
  border-radius: 50%;
  max-width: 100%;
  display: block;
  padding: 7px;
  position: relative;

  & > img {
    width: 100px;
    height: 100px;
  }
`;

export const OrderStatusContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  margin: 0 auto;
  padding-bottom: 20px;
  align-items: center;
  gap: 15px;
  flex-wrap: wrap;
  & > div {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  & > div p {
    color: var(--color);
  }
`;
